export enum TaskState {
  NotStarted,
  InProgress,
  Success,
  Failed,
}